import { useState, useEffect } from "react";

const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const media = window.matchMedia(query);
    const updateMatch = () => setMatches(media.matches);

    updateMatch(); // Set initial match
    media.addEventListener("change", updateMatch);

    return () => media.removeEventListener("change", updateMatch);
  }, [query]);

  return matches;
};

export default useMediaQuery;

// A  How to use this hook

// 1.  define hook

// 2. const isMobile = useMediaQuery('(max-width: 991px)');

// 3. Use this condition to render things

// 4. {isMobile ? true : false}
